import { render } from "./EditorField.vue?vue&type=template&id=000b2146"
import script from "./EditorField.vue?vue&type=script&lang=js"
export * from "./EditorField.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__